// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"25323":"de32c32678e365d4","31685":"6f284cf8215bd6fc","56083":"c43325341178a9c6","85608":"a7889e9eb7919ff1","90539":"28d9db99ee7c8811"}[chunkId] + ".css";
};